import Base64Image from 'component/Base64Image'
import styled from 'styled-components'
import themeAssetloadingSquareLoadingSvg from '@theme/loading/square-loading.svg'

export const AdImage = styled(Base64Image).attrs({
  aspectRatio: 900 / 240,
  source: 'picture',
  placeholder: themeAssetloadingSquareLoadingSvg,
})`
  width: 100%;
  border-radius: 0.2564rem;
`
